import React, { Component } from "react";
import {mapGenderSteps, uploadFileInstruction, mapType, reviewInstruction, genderMapOptions} from '../../../utils/constants';
import Steps from '../../../components/Steps/Steps';
import UploadFile from '../Components/UploadFile/UploadFile';
import MatchColumns from '../Components/MatchColumns/MatchColumns';
import Review from './../Components/Review/Review';
import MapColumns from './../Components/MapColumns/MapColumns';
import groupBy from 'lodash/groupBy';
import filter from 'lodash/filter';
import find from 'lodash/find';
import uniqBy from 'lodash/uniqBy';
import sortBy from 'lodash/sortBy';
import orderBy from 'lodash/orderBy'
import findIndex from 'lodash/findIndex';
import { deepClone } from "../../../utils/copyObject";
import axios from "../../../axios";
import * as url from "../../../utils/url";

export default class MapGender extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchedTerm : '',
      sortType : 'unmapped-first',
      mapOptions: genderMapOptions,
      error:false
    }
    console.log(genderMapOptions)
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    // console.log(this.props)
    // console.log('props 29-----',this.props)
    // let {allGenderMapping} = this.props.mapGender
    // const orgID = this.props.user.organizationId._id
    // let options
    // axios.get(url.getMasterListByCategory('GENDER')).then(({data}) => {
    //   const payload = data.data[0].docs;
    //    options = payload.map((i) => {
    //     const o = {};
    //     o.value = i._id;
    //     o.label = i.name;
    //     return o;
    //   });
    // })
    // axios.get(url.getExistingMappings(orgID)).then(({data}) => {
    //   const payload = data.data;
    //   let {mapping} = payload;
      // console.log('mppaing --- ', mapping)
    //   if(mapping && mapping.gender){
    //     mapping = mapping.gender.data.map(e=>{
    //       let column = e.key
    //       let obj;
    //         e.values.map(c=>{
    //           let v = e.key==="FEMALE"?"Female": e.key==="MALE"?"Male":"Other"
    //           obj = {column:{value:v,label:e.key}, value: c, mapped:true}
    //           return allGenderMapping.push(obj)
    //         })
    //     })
    //     console.log('all ---', allGenderMapping)
    //     this.props.saveAllGenderMapping(allGenderMapping)
    //     // this.props.saveAllGenderMapping(gm2)
    //   }
    // })

    const location = this.props.history.location;

      const unblock = this.props.history.block((location, action) => {
        if (action==='POP') return "You have not completed the process yet. Are you sure you want to leave without completing it?";
        // if (action==='PUSH' && !location.pathname.startsWith(`/home/analytics/${category}/create`)) return "You have not completed the process yet. Are you sure you want to leave without completing it?";
      }); 
      // Listen for changes to the current location.
      const unlisten = this.props.history.listen((location, action) => {
      // location is an object like window.location
        // console.log(action, location.pathname, location.state);
        if(location.pathname.indexOf("success")>-1 || location.pathname.indexOf("enterprise-info/map-gender")>-1 || location.pathname.indexOf("setup/map-gender") >-1) {
          unlisten();
          unblock();  
        }
      })
 
      // setTimeout(() => {
      //   window.history.forward()
      // }, 0)
      // window.onunload=function(){null};
  }

  handleFileUpload = (fields, data, file) => {
    const {matchedColumn} = this.props.mapGender;
    if(!fields.includes(matchedColumn)) {
      this.props.onMapGenderMatchColumn("");
    }
    this.props.onProcessedFileUploadData(fields, data, file);
    this.props.nextStep();
  }

  handleMatchGenderColumn = (matchedColumn) => {
    let {rowData,allGenderMapping} = this.props.mapGender;
    // console.log('ge--- ', this.props.mapGender)
    const orgID = this.props.user.organizationId._id
    const {isRepeatFlow} = this.props;
    const uniqueGenders = Object.keys(groupBy(rowData,(r) => r[matchedColumn]));
    console.log(uniqueGenders)
    this.props.onMapGenderMatchColumn(matchedColumn);

    if(isRepeatFlow) {
      allGenderMapping =[]
    axios.get(url.getExistingMappings(orgID)).then(({data}) => {
      const payload = data.data;
      let {mapping} = payload;
      // console.log('mppaing --- ', mapping)
      if(mapping && mapping.gender){
        mapping = mapping.gender.data.map(e=>{
          let column = e.key
          let obj;
            e.values.map(c=>{
              obj = {column:{value:e.key,label:e.key}, value: c, mapped:true}
              return allGenderMapping.push(obj)
            })
        })
        // console.log('all ---', allGenderMapping)
        this.props.saveAllGenderMapping(allGenderMapping)
      
      if (allGenderMapping.length > 0) {
        const filteredMapping = sortBy(filter(uniqueGenders,(g) => g != 'undefined' || g.value != 'null').map((f) => {
          // console.log(f)
           const found = find(allGenderMapping,(o) => o.value === f);
           if(found) {
             return {
               value : f,
               column : found.column,
               mapped: true
             }
           } else {
             return {
               value : f,
               column : '',
               mapped:false
             }
           }
         }),(o) => o.value);
        //  console.log(filteredMapping,'--',allGenderMapping);
        //  allGenderMapping.map(e=>e.column.value==="FEMALE"?"Female": e.column.value==="MALE"?"Male":"Other")
         let results = allGenderMapping.concat(filteredMapping)
         results = uniqBy(results, 'value')
         let results1=results
        //  results.map(e=>e.column.value==="FEMALE"?"Female": e.column.value==="MALE"?"Male":"Other")
        //  console.log('res --- ', results)
        

         let res = results.filter(e=> e.value!=null && e.value!='null').map(e=>{
           console.log('mapping====',e)
           if(e.column!==""){
             let obj = {
               value:e.value,
               mapped: e.mapped,
               column: {label:e.column!==""?e.column.value.charAt(0).toUpperCase() + e.column.value.slice(1).toLowerCase():"",value: e.column?e.column.value:""}
             }
             return obj
           } else {
             let val = e.value===undefined||e.value===null ||e.value==="null"|| e.value==="undefined"? e.value="empty":e.value
             let obj = {
               value:val,
               mapped: false,
               column: ""
             }
             return obj
           }
         })
         res = uniqBy(res, 'value')
        //  res = res.sort( (a,b) => a.mapped - b.mapped)
        //  console.log(res)
         this.props.saveAllGenderMapping(res);
         this.props.nextStep();
        } else {
            const mappingArray = sortBy(filter(uniqueGenders,(g) => g != 'undefined' || g != 'null').map((gender) => {
            const z = {};
            z.value = gender;
            z.column = ''
            return z;
          }),(o) => o.value);
          this.props.saveAllGenderMapping(mappingArray);
          this.props.nextStep();
        }
      } else {
            const mappingArray = sortBy(filter(uniqueGenders,(g) => g != 'undefined' || g != 'null').map((gender) => {
            const z = {};
            z.value = gender;
            z.column = ''
            return z;
          }),(o) => o.value);
          this.props.saveAllGenderMapping(mappingArray);
          this.props.nextStep();
        }
    })
  }else {
    const mappingArray = sortBy(filter(uniqueGenders,(g) => g != 'undefined' || g != 'null').map((gender) => {
      const z = {};
      z.value = gender;
      z.column = ''
      return z;
    }),(o) => o.value);
    this.props.saveAllGenderMapping(mappingArray);
    this.props.nextStep();
  }
}

  handleMapColumnContinue = () => {
    let {allGenderMapping} = this.props.mapGender;
    // console.log('allGender--- ', allGenderMapping)
    
    // const invalidRecords = filter(allGenderMapping,(o) => !o.column || o.column==="");
    // // console.log('invalid ---', invalidRecords)
    // if(invalidRecords.length>0){
    //   this.setState({error:"Please map all the values from your .csv to the standardized values using the dropdowns."})
    //   return
    // } else {
    //   this.setState({error:false})
    //     this.props.nextStep()
    // }
    this.props.nextStep()

    // const invalid = allGenderMapping.filter((o) => {
    //   if(o.column.length === 0) {
    //     return true;
    //   }
    //   return false;
    // })
    // if(invalid.length > 0) {
    //   return;
    // } else {
    //   this.props.nextStep();
    // }
  }

  handleGenderMapped = (gender,column) => {
    // console.log(column,'=mapped-- ', gender)
    const {allGenderMapping} = this.props.mapGender;
    const allGender = deepClone(allGenderMapping);
    const i = findIndex(allGender,{value : gender.value});
    allGender.splice(i,1,{value:gender.value,column:column, mapped:gender.mapped})
    this.props.saveAllGenderMapping(allGender);
  }

  handleSearchQueryChange = ({name,value}) => {
    this.setState({
      searchedTerm : value
    })
  }

  handleContinue = () => {
    const {allGenderMapping} = this.props.mapGender;
    const {isRepeatFlow} = this.props;
    const groupedMapping = groupBy(allGenderMapping,(m) => m.column.value);
    // console.log('165--- ', allGenderMapping)
    // console.log(groupedMapping);
    let data = [];
    for(let key in groupedMapping) {
      // console.log(groupedMapping[key]);
      data.push({
        key : key,
        values : groupedMapping[key].map((o) => o.value)
      })
    }
    data = data.filter(o => o.key!==undefined && o.key!=="undefined")
    // console.log(data);
    data = data.filter(o => o.key!==undefined && o.key!=="undefined")

    // console.log(data);
    const {matchedColumn} = this.props.mapGender;
    // console.log(matchedColumn);
    const payload = {
      mappingType : "gender",
      columnName : matchedColumn,
      data : data
    }
    console.log(payload);
    // return
    axios.post(url.saveMapping,payload).then(({data}) => {
      // console.log(data);
      if(isRepeatFlow) {
        this.props.history.push({pathname : 'success',state : {type : 'gender'}});
        this.props.reset();
      } else {
        this.props.history.push('map-positions');
      }
    })
  }

  handleonSortChange = (sortType) => {
    this.setState({
      sortType : sortType
    });
  }

  render() {
    let {currentStep, allColumns, rowData, file, matchedColumn, allGenderMapping} = this.props.mapGender;
    // console.log("Map Gender State",this.props.mapGender);
    const {isRepeatFlow} = this.props;
    const {searchedTerm,sortType,mapOptions} = this.state;
    return (<div className={"mb30" + isRepeatFlow ? 'mt30' : 'mt70'}>
    <div className="map-gender-title mt30 mb30">Map Gender</div>
      <Steps steps={mapGenderSteps} currentStep={currentStep} />
      {
          currentStep === 1 ? 
          <UploadFile
            top="mt40"
            instruction={uploadFileInstruction.mapGender}
            allColumns={allColumns}
            rowData={rowData}
            file={file}
            type={mapType.gender}
            labelSize={4}
            labelText="File with Gender Information"
            allowedFileSize={20}
            uploadFileHint="(Only .csv files, maximum 20MB file size)"
            onFileUpload={this.handleFileUpload}
            isRepeatFlow={isRepeatFlow}
          /> : 
          currentStep === 2 ?
            <MatchColumns
              goBack={this.props.goBack}
              top="mt40"
              instruction="Please match the column with gender information."
              csvFields = {allColumns}
              csvData = {rowData}
              type={mapType.gender}
              mappingPositions={true}
              matchedColumns={matchedColumn!=="" ? [matchedColumn] : []}
              allowMoreColumnsMatch={false}
              nextBtnTxt='Continue'
              onMatchedColumn={this.handleMatchGenderColumn}
            /> : 
          currentStep === 3 ?
            <MapColumns
              allDataMapping={allGenderMapping}
              mapOptions={mapOptions}
              type={mapType.gender}
              onRowMapped={this.handleGenderMapped}
              nextStep={this.handleMapColumnContinue}
              goBack={this.props.goBack}
              searchedTerm={searchedTerm}
              error={this.state.error}
              sortType={sortType}
              onSearchQueryChange={this.handleSearchQueryChange}
              onSortChange={this.handleonSortChange}
              mapSelectPlaceholder= "Map to gender category"
              optionTypeTxt="Gender"
              mappingTableHeader="Gender"
              searchBarPlaceholder="Search by gender"
              mappingSubHeaderTxt="Please map the gender information from your .csv to standardized gender categories."
            /> :
          currentStep === 4 ?
            <Review
              top="mt40"
              instruction={reviewInstruction.mapGender}
              goBack={this.props.goBack}
              nextBtnAction={this.handleContinue}
              type={mapType.gender}
              mapOptions={mapOptions}
              file={file}
              reviewHeading="These are your final selections for the mapping. "
              nextBtnTxt={isRepeatFlow ? 'Finish' : 'Next Step'}
              isRepeatFlow={isRepeatFlow}
              {...this.props}
            />:
             null
        }
    </div>);
  }
}
